//============================================================================
// Name        : Table.tsx
// Purpose     : Implement Edit Schedule Calencar View
// Created     : 2019-08-19
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

// tslint:disable-next-line: no-unused-expression
/** @jsx jsx */ jsx;
import { css, jsx } from "@emotion/core";
import React from "react";
import { connect } from "react-redux";
import { IUpdateStateAction } from "./actions/editScheduleActions";
import ICRow from "./ICRow";
import TableColumn from "./TableColumn";
import { EditScheduleActions, IProduction, IReduxReducers, IStorageUnit, IUser } from "./types";

const titleDiv = css`
    font-weight: bold;
    font-size: 11px;
    text-align: center;
    border: 1px solid #ccc;
    border-bottom: none;
    height: 20px;
    background: #dcdcdc linear-gradient(to bottom, rgba(250,250,250,1) 0%, rgba(242,242,242,1) 47%, rgba(224,224,224,1) 100%);
`;

const normalTable = css`
    display: flex;
`;

const scrollableTable = css`
    max-width: 320px;
    overflow-x: auto;
    // box-shadow: inset 11px 0px 6px -11px #d2d2d2, inset -11px 0px 4px -10px #d2d2d2;
`;

export interface IScheduleCalendarViewState {
    children: any;
    title?: string;
    totals: boolean;
    totalsHeaderTitle?: string;
    totalsHeaderSubtitle?: string;
    totalsFooter?: string;
    scrollable?: boolean;
    maxWidth?: number;

    schedulerUsers?: IUser[];
    productions?: IProduction[];
    pastDueProductions?: IProduction[];
    storageUnit: IStorageUnit;
    showAsLbs: boolean;
    showAsCases: boolean;
}

class Table extends React.Component<IScheduleCalendarViewState> {
    sumProductionsForUser = (userId: number) => {
        return this.props.productions.filter(p => p.scheduler_user_id == userId)
            .reduce((acc, p) => acc + p.needed_qty, 0);
    }

    sumPastDuePerUser = (userId: number): number => {
        return this.props.pastDueProductions.filter(p => p.scheduler_user_id == userId)
            .reduce((accTotal, p) => accTotal + p.needed_qty, 0);
    }

    valueInUnits = (value: number): JSX.Element => {
        const cases = value / parseFloat(this.props.storageUnit.measure_unit);
        return (
            <React.Fragment>
                {this.props.showAsLbs && <div>{value}</div>}
                {this.props.showAsCases && <div>{cases}</div>}
            </React.Fragment>
        );
    }

    render() {
        const showTitle = this.props.title != undefined;
        const maxWidth = this.props.maxWidth ? this.props.maxWidth : "";
        return (
            <div>
                {showTitle && <div css={titleDiv}>{this.props.title}</div>}
                {!showTitle && <div css={{ marginTop: 35 }}></div>}

                <div css={{ display: "flex", justifyContent: "space-between" }}>
                    {/* Loop days on view, and add columns */}
                    {this.props.scrollable && <div css={[normalTable, scrollableTable, { maxWidth }]}>
                        {this.props.children}
                    </div>}

                    {!this.props.scrollable && <div css={normalTable}>
                        {this.props.children}
                    </div>}

                    {/* Add Totals column */}
                    {this.props.totals && !this.props.title.includes("Past-Due") && <div css={{ marginLeft: 20 }}>
                        <TableColumn headerHeight={30} headerTitle={this.props.totalsHeaderTitle} headerSubtitle={this.props.totalsHeaderSubtitle}
                                     footer={this.props.totalsFooter} pastDue={false}>

                            {this.props.schedulerUsers.map((user: IUser, key) =>
                                <ICRow key={key} content={this.valueInUnits(this.sumProductionsForUser(user.id))} showDividers={true} />
                            )}
                        </TableColumn>
                    </div>}

                    {/* Add Past-Due Totals column */}
                    {this.props.totals && this.props.title.includes("Past-Due") && <div css={{ marginLeft: 20 }}>
                        <TableColumn headerHeight={30} headerTitle={this.props.totalsHeaderTitle} headerSubtitle={this.props.totalsHeaderSubtitle}
                                     footer={this.props.totalsFooter} pastDue={true}>

                            {this.props.schedulerUsers.map((user: IUser, key) =>
                                <ICRow key={key} content={this.valueInUnits(this.sumPastDuePerUser(user.id))} showDividers={true} />
                            )}
                        </TableColumn>
                    </div>}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IReduxReducers) => ({
    schedulerUsers:     state.editSchedule.schedulerUsers,
    productions:        state.editSchedule.productions,
    pastDueProductions: state.editSchedule.pastDueProductions,
    storageUnit:        state.editSchedule.storageUnit,
    showAsLbs:          state.editSchedule.showAsLbs,
    showAsCases:        state.editSchedule.showAsCases
});

const mapDispatchToProps = dispatch => ({
   updateState: (newState: object) => dispatch({
        type: EditScheduleActions.UpdateState,
        payload: newState
    } as IUpdateStateAction)
});

export default connect(mapStateToProps, mapDispatchToProps)(Table);
